<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<!-- <router-outlet><app-spinner></app-spinner></router-outlet> -->
<router-outlet>
    <ng-http-loader
        [backdrop]="true" [debounceDelay]="100" [minDuration]="50"
        [opacity]=".6" [extraDuration]="50" [backdropBackgroundColor]="'#777777'"
        [backgroundColor]="'#ff0000'" [spinner]="spinkit.skWave">
    </ng-http-loader>
</router-outlet>
